export enum MonthOfYearEnum {
  NA,
  January,
  February,
  March,
  April,
  May,
  June,
  July,
  August,
  September,
  October,
  November,
  December
}

export namespace MonthOfYearEnum {
  export function values() {
    return Object.keys(MonthOfYearEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
